import t from "styled-components";
const i = t.div`
  height: 100%;
  overflow: auto;
  width: 100%;
`, e = t.div`
  width: 100%;
`;
export {
  e as ContentList,
  i as Wrapper
};
